import React from 'react';
import { healingImage } from '../mock';

const PathToHealing = () => {
  return (
    <section className="py-16 lg:py-24 bg-neutral-50">
      <div className="max-w-[1240px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative rounded-[24px] overflow-hidden aspect-[4/5] lg:aspect-[5/6]">
          <img
            src={healingImage}
            alt="Physiotherapist stretching patient's leg"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>

        <div>
          <h2 className="text-[40px] lg:text-[54px] leading-[0.98] font-bold tracking-tight text-neutral-900">
            Your Path to <br />
            <span className="font-serif-italic font-normal">Recovery Begins Here</span>
          </h2>

          <div className="mt-10 space-y-8">
            <div className="border-t border-neutral-200 pt-6">
              <h3 className="text-[19px] font-semibold text-neutral-900">A Careful First Assessment</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-neutral-600 max-w-md">
                Every plan begins with a thorough, unhurried assessment. We take time to
                understand your history, your goals, and how your body moves—because the right
                plan starts with the right questions.
              </p>
            </div>
            <div className="border-t border-neutral-200 pt-6">
              <h3 className="text-[19px] font-semibold text-neutral-900">Evidence-Informed, Empathetic Care</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-neutral-600 max-w-md">
                Our clinicians blend hands-on therapy, therapeutic exercise, and clear
                education so you understand your body and stay involved in your plan.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PathToHealing;
